import { DropdownMenuItem } from '@trellis/roots/dropdown-menu'
import { DownloadIcon, FilePlusCorner } from 'lucide-react'

import type { PdfActionState } from './usePdfAction'

interface PdfActionMenuItemProps {
  action: PdfActionState
}

export function PdfActionMenuItem({ action }: PdfActionMenuItemProps) {
  const Icon = action.kind === 'download' ? DownloadIcon : FilePlusCorner

  const isDisabled =
    action.kind === 'loading' ||
    action.kind === 'blocked' ||
    (action.kind === 'download' && action.isDisabled)

  return (
    <DropdownMenuItem
      disabled={isDisabled}
      onSelect={'onSelect' in action ? action.onSelect : undefined}
    >
      <Icon className="mr-2 size-4" />
      {action.label}
    </DropdownMenuItem>
  )
}
